import { render, staticRenderFns } from "./WinLose.component.vue?vue&type=template&id=5777ef2e&"
import script from "./WinLose.component.vue?vue&type=script&lang=ts&"
export * from "./WinLose.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports